import { EBuyPackageSource } from '../../../../../../../../types/microfrontends/buyPackage';
import { EPackageType } from '../../../../../../../../types/reducers/recommendedPackages';

export const mapWidgetSource = (type: EPackageType): EBuyPackageSource => {
  switch (type) {
    case EPackageType.AllIn:
      return EBuyPackageSource.AddFormAllIn;

    case EPackageType.SmartPackage:
      return EBuyPackageSource.AddFormSmartPack;

    default:
      return EBuyPackageSource.AddForm;
  }
};
